export enum CacheTags {
  Contacts = `Contacts`,
  SingleContact = `SingleContact`,
  ContactAISummary = `ContactAISummary`,
  ContactActivities = `ContactActivities`,
  ContactStatement = `ContactStatement`,
  ContactApplicablePolicies = `ContactApplicablePolicies`,
  ContactAggNames = `ContactAggNames`,
  Policies = `Policies`,
  Organisations = `Organisations`,
  Groups = `Groups`,
  Settings = `Settings`,
  CustomDomain = `CustomDomain`,
  Webhooks = `Webhooks`,
  Subscriptions = `Subscriptions`,
  Actions = `Actions`,
  DashActions = `DashActions`,
  Escalations = `Escalations`,
  EmailTemplates = `EmailTemplates`,
  Invoices = `Invoices`,
  User = `User`,
  Accounts = `Accounts`,
  BrandingThemes = `BrandingThemes`,
  AuditLogs = `AuditLogs`,
  StripeAccount = `StripeAccount`,
  CustomerPayments = `CustomerPayments`,
  Files = `Files`,
  ActionCreateStatus = `ActionCreateStatus`,
  MobileNumberCheck = `MobileNumberCheck`,
  ContactTags = `ContactTags`,
  InvoiceTags = `InvoiceTags`,
  Quotes = `Quotes`,
  EmailReport = `EmailReport`,
  BadContacts = `BadContacts`,
  BadInvoices = `BadInvoices`,
  SystemPolicies = `SystemPolicies`,
  PreviewPolicy = `PreviewPolicy`,
  ActionPreview = `ActionPreview`,
  Credits = `Credits`,
  Communications = `Communications`,
  PaymentPlans = `PaymentPlans`,
  PaymentPromises = `PaymentPromises`,
  InvoiceQueries = `InvoiceQueries`,
  /** Promises, queries and plans recorded from a call, by contact_call id */
  CallFollowUps = `CallFollowUps`,
  ApiTokens = `ApiTokens`,
  ConnectedApps = `ConnectedApps`,
  CreditScoreConfig = `CreditScoreConfig`,
  AgentConversations = `AgentConversations`,
  AgentPrompts = `AgentPrompts`,
  AgentToolApprovals = `AgentToolApprovals`,
  AgentSettings = `AgentSettings`,
  SavedFilters = `SavedFilters`,
  StatementBuilder = `StatementBuilder`,
  ExportTasks = `ExportTasks`,
  Assistant = `Assistant`,
  PhoneNumbers = `PhoneNumbers`,
  Wallet = `Wallet`,
}

